import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Icon } from '@homeexchange/design';

import i18n from '../../i18n';

import Api from '../../api/Api';

import Home from '../../models/Home';
import User from '../../models/User';
import { connect } from 'react-redux';

import ExchangeBreadcrumb from './ExchangeBreadcrumb';
import Tooltip from '../widget/Tooltip';
import Conversation from '../../models/Conversation';
import { getConversationStatus } from '../../utils/stayRequest';

export class ExchangeHeader extends React.Component {
    static propTypes = {
        conversation: PropTypes.instanceOf(Conversation).isRequired,
        user: PropTypes.instanceOf(User).isRequired,
        actions: PropTypes.object.isRequired,
        onClose: PropTypes.func.isRequired,
        card: PropTypes.string,
        componentsShowed: PropTypes.shape({
            homeLink: PropTypes.bool,
            userLink: PropTypes.bool,
            exchangeType: PropTypes.bool,
            exchangePanels: PropTypes.bool
        }),
        stayRequestStatus: PropTypes.string
    };

    static defaultProps = {
        componentsShowed: {
            homeLink: true,
            userLink: true,
            exchangeType: true,
            exchangePanels: true
        }
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            home: null
        };

        // get interlocutor's home
        const exchangeAsGuest = this.props.conversation.getExchangeAsGuest();
        if (exchangeAsGuest) {
            this.state.home = exchangeAsGuest.get('home');
        }

        this.headerRef = React.createRef();
        this.showLoader = this.showLoader.bind(this);
        this.handleReportAbuse = this.handleReportAbuse.bind(this);
        this.handleArchive = this.handleArchive.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.loadHome = this.loadHome.bind(this);
        this.closeCard = this.closeCard.bind(this);
        this.openDetailsCard = this.openDetailsCard.bind(this);
    }

    componentDidMount() {
        this.headerRef.current.addEventListener('loading', this.showLoader);

        // get interlocutor's home
        if (!this.state.home) {
            this.loadHome(this.props.conversation.get('interlocutor').id);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.conversation.id !== nextProps.conversation.id) {
            const exchangeAsGuest = nextProps.conversation.getExchangeAsGuest();
            if (exchangeAsGuest) {
                this.setState({
                    home: exchangeAsGuest.get('home')
                });
            } else {
                this.loadHome(nextProps.conversation.get('interlocutor').id);
            }
        }
    }

    componentDidUpdate() {
        $(this.headerRef.current).removeClass('load');
    }

    componentWillUnmount() {
        this.headerRef.current.removeEventListener('loading', this.showLoader);
    }

    loadHome(userId) {
        Api.Home.get(
            {
                user: userId,
                status: Home.STATUS_ONLINE
            },
            { fullCompletionDate: 'DESC' },
            1000
        ).then((homes) => {
            const home = homes && homes.length > 0 ? new Home(_.first(homes)) : null;
            this.setState({ home });
        });
    }

    showLoader() {
        $(this.headerRef.current).addClass('load');
    }

    handleReportAbuse(e) {
        e.preventDefault();
        const content = (
            <div>
                <select name="select-type-abuse" className="form-control" id="select-type-abuse">
                    <option>{i18n.t('messaging:abuse_message_rental')}</option>
                    <option>{i18n.t('messaging:abuse_message_askid')}</option>
                    <option>{i18n.t('messaging:abuse_message_askdeposit')}</option>
                    <option>{i18n.t('messaging:abuse_message_spam')}</option>
                    <option>{i18n.t('messaging:abuse_message_hateful')}</option>
                    <option>{i18n.t('messaging:abuse_message_other')}</option>
                </select>
                <div className="form-group">
                    <textarea
                        id="msg-abuse"
                        className="form-control"
                        placeholder={i18n.t('messaging:abuse_message_placeholder')}
                        rows="5"
                    ></textarea>
                </div>
            </div>
        );
        sweetAlert({
            title: i18n.t('messaging:report_abuse_title', {
                first_name: this.props.conversation.get('interlocutor').get('first_name')
            }),
            content,
            icon: 'warning',
            buttons: {
                cancel: {
                    text: i18n.t('common:cancel'),
                    visible: true
                },
                confirm: {
                    text: i18n.t('common:continue'),
                    closeModal: false
                }
            }
        }).then((isConfirm) => {
            if (!isConfirm) {
                return;
            }
            // abuse message must be defined if "other" reason is selected
            if (
                $('#select-type-abuse').val() === i18n.t('messaging:abuse_message_other') &&
                $('#msg-abuse').val().trim().length === 0
            ) {
                $('#msg-abuse').closest('.form-group').addClass('has-error');
                sweetAlert.showInputError(i18n.t('common:required'));
                return false;
            }
            // send mail to contact
            Api.Utils.contact({
                email: this.props.user.get('email'),
                locale: i18n.language,
                subject: `Abuse: ${$('#select-type-abuse').val()}`,
                message: $('#msg-abuse').val(),
                status: 'new',
                priority: 'high',
                tags: ['abuse', 'message'],
                extra_informations: [
                    `user ${this.props.user.id}`,
                    `interlocutor ${this.props.conversation.get('interlocutor').id}`,
                    `conversation ${this.props.conversation.id}`
                ]
            }).always(() => {
                sweetAlert.close();
            });
        });
    }

    handleArchive() {
        if (this.props.conversation.isArchived()) {
            this.props.actions.unarchiveConversation(this.props.conversation.id);
        } else {
            this.props.actions.archiveConversation(this.props.conversation.id);
        }
    }

    handleDelete() {
        sweetAlert({
            title: i18n.t('messaging:delete_confirm.title'),
            text: i18n.t('messaging:delete_confirm.text_count', { count: 1 }),
            icon: 'warning',
            buttons: [i18n.t('messaging:delete_confirm.cancel'), i18n.t('messaging:delete_confirm.confirm')]
        }).then((confirm) => {
            if (confirm) {
                const promise = this.props.actions.deleteConversation(this.props.conversation.id);
                promise.catch((err) => {
                    sweetAlert({
                        icon: 'error',
                        title: i18n.t('messaging:conversation_cannot_be_delete'),
                        text:
                            err.status == 409
                                ? i18n.t(`exchange:${err.responseJSON.errors.code}`)
                                : i18n.t(err.responseText)
                    });
                });
            }
        });
    }

    closeCard(event) {
        event.preventDefault();
        document.dispatchEvent(new CustomEvent('dismiss_card'));
        // close exhange type collapse panel
        $('#collapseExchangeType').collapse('hide');
    }

    openDetailsCard(event) {
        event.preventDefault();
        document.dispatchEvent(
            new CustomEvent('request_card', {
                detail: {
                    view: 'details'
                }
            })
        );
    }

    render() {
        const { stayRequestStatus, conversation } = this.props;
        const { slug, label } = getConversationStatus(stayRequestStatus, conversation);
        return (
            <div
                className={classNames('exchange-header', `header-${this.props.card || 'conversation'}`)}
                ref={this.headerRef}
            >
                <a href="#" onClick={this.props.onClose} className="btn back hidden-lg">
                    <Icon name="Menu" size="large" aria-hidden="true" />
                    <span className="sr-only">{i18n.t('common:close')}</span>
                </a>

                <div
                    className={classNames('conversation-status visible-xs visible-sm status', slug, {
                        'hidden-xs hidden-sm': this.props.card === 'details'
                    })}
                >
                    {label}
                </div>

                <div className="hidden-xs hidden-sm">
                    <ExchangeBreadcrumb conversation={this.props.conversation} user={this.props.user} />
                </div>

                <div className="flex-spacer"></div>

                {(() => {
                    if (!this.props.card) {
                        const archiveLabel = this.props.conversation.isArchived()
                            ? i18n.t('messaging:action_unarchive')
                            : i18n.t('messaging:action_archive');
                        return (
                            <div className="dropdown hidden-xs pull-right">
                                <button
                                    className="btn btn-circle dropdown-toggle"
                                    type="button"
                                    id="dropdownExtra"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    <Icon name="DotsHorizontal" size="large" />
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownExtra">
                                    <li>
                                        <a href="#" onClick={this.handleArchive}>
                                            <Icon name="ArchiveBox" size="medium" /> {archiveLabel}
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={this.handleDelete}>
                                            <Icon name="Trash" size="medium" />{' '}
                                            {i18n.t('messaging:action_delete')}
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#" onClick={this.handleReportAbuse}>
                                            <Icon name="ExclamationCircleOutline" size="medium" />{' '}
                                            {i18n.t('messaging:report_abuse')}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        );
                    }
                })()}

                {this.props.componentsShowed.homeLink && this.state.home && this.state.home.isPublished() && (
                    <Tooltip
                        placement="bottom"
                        title={i18n.t('messaging:home_link', {
                            first_name: this.props.conversation.get('interlocutor').get('first_name')
                        })}
                    >
                        <a
                            href={i18n.t('home:home.view.url', {
                                id: this.state.home.id
                            })}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-circle-o hidden-xs hidden-sm"
                        >
                            <Icon name="Home" />
                        </a>
                    </Tooltip>
                )}

                {this.props.componentsShowed.userLink && (
                    <Tooltip
                        placement="bottom"
                        title={i18n.t('messaging:user_link', {
                            first_name: this.props.conversation.get('interlocutor').get('first_name')
                        })}
                    >
                        <a
                            href={i18n.t('user:user.view.url', {
                                id: this.props.conversation.get('interlocutor').id
                            })}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-circle-o hidden-xs hidden-sm"
                        >
                            <Icon name="User" />
                        </a>
                    </Tooltip>
                )}

                {this.props.componentsShowed.exchangePanels && (
                    <div className="exchange-panels">
                        <a
                            href="#"
                            className={classNames('btn btn-conversation', {
                                active: !this.props.card
                            })}
                            onClick={this.closeCard}
                            title={i18n.t('messaging:conversation')}
                        >
                            <Icon name="ChatBubbles" />
                            <span className="sr-only">{i18n.t('messaging:conversation')}</span>
                        </a>
                        <a
                            href="#"
                            className={classNames('btn btn-details', {
                                active: this.props.card === 'details'
                            })}
                            onClick={this.openDetailsCard}
                            title={i18n.t('messaging:details')}
                        >
                            <Icon name="Calendar" />
                            <span className="sr-only">{i18n.t('messaging:details')}</span>
                        </a>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state, { conversation }) => ({
    stayRequestStatus:
        state?.stayRequest?.stayRequestByConversationId?.[conversation.id]?.stayRequests?.stayRequestStatus
});

export default connect(mapStateToProps)(ExchangeHeader);
